module.exports = __webpack_public_path__ + "static/media/tSquaredLogo.18f6f266.png";